import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-support-nav',
  templateUrl: './nested-support-nav.component.html',
  styleUrls: ['./nested-support-nav.component.scss']
})
export class NestedSupportNavComponent implements OnInit {

  url = {
    discontinuedproducts: '8',
    financing: '1',
    howtobuy: '2',
    productregistration: '3',
    rmarequest: '4',
    software: '5',
    supportbulletins: '6',
    warranty: '7',
    "end-of-life-eol-policy-statement": '9',
  };

  data: any;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {
    let temp = window.location.href.split('/');
    this.data = this.url[temp[temp.length - 1]];
    if(temp[temp.length - 1].includes('?')){
      temp = temp[temp.length - 1].split('?');
      this.data = this.url[temp[0]];
    }
  }
}
